interface IConfig {
  baseURL: string
  webLogUrl: string
  gaMeasurementId: string
  baseSecret: string
  transponderURL: string
  // homeURL: string
  ossCdnUrl: string
  slsURL: string
  beginPublicKey: string
  universalHost: string
  aliOssURL: string
  secretKey: string
  aiCustomerURL: string
  aiCustomerSecretKey: string
}

const config: IConfig = {
  baseURL: process.env.VUE_APP_BASE_URL || '',
  webLogUrl: process.env.VUE_APP_WEB_LOG_URL || '',
  gaMeasurementId: process.env.VUE_APP_GA_MEASUREMENT_ID || '',
  baseSecret: process.env.VUE_APP_BASE_SECRET || '',
  transponderURL: process.env.VUE_APP_TRANSPONDER_URL || '',
  // homeURL: process.env.VUE_APP_HOME_URL || '',
  ossCdnUrl: process.env.VUE_APP_OSS_CDN_URL || '',
  slsURL: process.env.VUE_APP_SLS_URL || '',
  beginPublicKey: process.env.VUE_APP_BEGIN_PUBLIC_KEY || '',
  universalHost: process.env.VUE_APP_UNIVERSAL_HOST || '',
  aliOssURL: process.env.VUE_APP_ALI_OSS_URL || '',
  secretKey: process.env.VUE_APP_SECRET_KEY || '',
  aiCustomerURL: process.env.VUE_APP_AI_CUSTOMER_URL || '',
  aiCustomerSecretKey: process.env.VUE_APP_AI_CUSTOMER_SECRET_KEY || ''
}
console.log(`------- 当前环境: ${process.env.VUE_APP_ENV} -------`)

export default config
